import { getOutsideEventTarget } from './outside-interaction';

/**
 * A dialog should only dismiss on an outside interaction with the app's own UI:
 * the modal's backdrop overlay, or — for an overlay-less dialog — the page
 * behind it.
 *
 * Browser extensions (password managers such as 1Password, LastPass, Bitwarden;
 * translators; etc.) inject their inline field toggles and menus on top of the
 * page, outside the app root. Clicking one fires Reka's outside-interaction
 * events, which the dismissable layer treats as a click-outside and closes the
 * dialog — discarding whatever the user was typing. We ignore any interaction
 * that did not originate from our own UI rather than trying to enumerate every
 * extension (their markers differ: custom elements, body-level iframes, plain
 * divs — and change over time).
 */
export function isAppElement(target: EventTarget | null): boolean {
	if (!(target instanceof Element) || !target.isConnected) return false;

	// The main application subtree.
	if (target.ownerDocument.querySelector('#__nuxt')?.contains(target)) return true;

	// A modal renders its overlay/content in a portal outside the app root; the
	// backdrop is the legitimate "click outside" target for dismissal.
	return target.closest('[data-slot="overlay"]') !== null;
}

export function preventExtensionDismiss(event: Event): void {
	if (!isAppElement(getOutsideEventTarget(event))) {
		event.preventDefault();
	}
}
